module.exports = flarum.reg.get('core', 'forum/app');